import * as React from "react"

const SvgLongArrowUp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M13 7.989v11.153a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.288.97.97 0 0 1-.712-.288.97.97 0 0 1-.287-.713V7.99l-2.849 2.85q-.3.3-.7.288a1.02 1.02 0 0 1-1.012-1 .93.93 0 0 1 .288-.713L11.3 4.838a.9.9 0 0 1 .325-.213q.175-.062.375-.062c.2 0 .258.02.375.062a.9.9 0 0 1 .325.213l4.572 4.576q.3.3.287.713a1.02 1.02 0 0 1-1.012 1 .92.92 0 0 1-.7-.287z" />
  </svg>
)
export default SvgLongArrowUp
